// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { ShiftBase } from '../../SagaBase/ShiftBase';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class Shift_abstract extends ShiftBase {
  static $t: string = 'SagaBase.Shift';
  $t: string = 'SagaBase.Shift';

  public static GetMembers(): string[] {
    return ['IsEnabled', 'Name', 'Value'].concat(ShiftBase.GetMembers());
  }

  public GetMembers(): string[] {
    return Shift_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public IsEnabled: boolean = true;
  public Name: string = '00.00-00.00';
  public Value: any;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
